import { render, staticRenderFns } from "./Teachable.vue?vue&type=template&id=78b84909&scoped=true&"
import script from "./Teachable.vue?vue&type=script&lang=js&"
export * from "./Teachable.vue?vue&type=script&lang=js&"
import style0 from "./Teachable.vue?vue&type=style&index=0&id=78b84909&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b84909",
  null
  
)

component.options.__file = "Teachable.vue"
export default component.exports